import React from 'react';
import { CheckCircle } from 'lucide-react';

const benefits = [
  "Geprüfter Elektromeister für Elektrotechnik, Automatisierungs- und Informationstechnik",
  "Professionelle Planung und Dokumentation",  
  "Herstellerunabhängiger Service",
  "Über 15 Jahre Erfahrung",
  "Notfall Support", 
  "Kosteneffiziente Lösungen"
];

const AboutSection = () => {
  return <section id="about" className="py-20 pb-0 bg-secondary/20">
    <div className="container">
      <div className="flex flex-col lg:flex-row items-center gap-12">
        <div className="lg:w-1/2">
          <div className="relative">
            <img src="https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?ixlib=rb-4.0.3&auto=format&fit=crop&q=80" alt="Über uns" className="w-full h-auto rounded-lg shadow-lg" />
            <a 
              href="https://handwerk.check24.de/craftsmen/cs/profile/sp_mEnvd" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="absolute -bottom-6 -right-6 bg-white p-4 rounded-lg shadow-lg hidden md:block hover:shadow-xl transition-all duration-300 hover:scale-110"
            >
              <div className="flex items-center gap-3">
                <div className="rounded-full flex items-center justify-center">
                  <img src="https://cdn.profis.check24.de/widget/2022.svg" alt="Check24 Verified" className="w-20 h-20 object-contain" />
                </div>
                <div>
                  <p className="text-paragraph text-base">Zusammenarbeit mit</p>
                  <p className="font-bold text-lg">Check24 Profi</p>
                </div>
              </div>
            </a>
          </div>
        </div>
        
        <div className="lg:w-1/2 space-y-6">
          <h2 className="text-primary text-3xl md:text-4xl font-bold">Ihr Partner für eine professionelle Elektroinstallation</h2>
          <p className="text-paragraph text-justify text-align-last-none">
            Als eingetragener Elektromeister in der örtlichen Handwerkskammer und im Elektro-Installateurverzeichnis ist Dietronik-Service Ihr Ansprechpartner, wenn es sich um Probleme oder neue Projekte in folgenden Bereichen der Elektrotechnik handelt: - Elektroinstallationsarbeiten im Neu- / Altbau / Gewerbebau - Neuverdrahtung inkl. Zählerschrank - Videoüberwachung und Einbruchmeldetechnik wie Alarmanlagen - Service- / Reparaturarbeiten - E-Check / Wiederholungsprüfungen Von der genauen Analyse über die Beratung bis hin zur fachgerechten Durchführung, alles aus einer Hand.
          </p>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-4">
            {benefits.map((benefit, index) => (
              <div 
                key={index} 
                className="flex items-center gap-2 p-2 rounded-md transition-all duration-300 hover:bg-white/50 hover:shadow-sm hover:scale-110"
              >
                <CheckCircle size={20} className="text-primary flex-shrink-0" />
                <span className="text-paragraph">{benefit}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>;
};

export default AboutSection;
